// extracted by mini-css-extract-plugin
module.exports = {"language":"LanguageSelect_language__3GUO3","icon":"LanguageSelect_icon__fFG0f"};